<template>
  <div class="form" style="padding:29px 29px 0;border-bottom:1px solid #F2F2F2;">
    <span class="title">{{title}}</span>
    <el-form
      :inline="true"
      :model="conditon"
      class="demo-form-inline"
      style="margin-top:20px;"
      size="small"
    >
      <slot name="season"></slot>
      <el-form-item label="是否已办联名卡">
        <el-select v-model="conditon.isCard" placeholder="不限" style="width:100px;">
          <el-option label="不限" value></el-option>
          <el-option label="是" value="是"></el-option>
          <el-option label="否" value="否"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="常运营省份">
        <el-select v-model="conditon.provName" placeholder="不限" style="width:150px;">
          <el-option label="不限" value></el-option>
          <el-option
            v-show="provinceList.length"
            v-for="(item,index) in provinceList"
            :key="index"
            :label="item.provinceName"
            :value="item.provinceName"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button @click="exportDate" v-show="hideExport">导出</el-button>
        <el-button @click="search">查询</el-button>
        <el-button @click="prev">返回上级</el-button>
        <slot name="exportData"></slot>
      </el-form-item>
    </el-form>
  </div>
</template>
<script>
/**
 * @file:  View 组件 form
 * @author: v_chengmengya
 * @date: 2019-05-15
 * @description: UI组件
 */
import { hideExport } from '@/utils/tools'
export default {
  data(){
    return{
       hideExport:hideExport,
    }
  },
  props: {
    title: {
      default: '',
      type: String
    },
    conditon: {
      defualt: () => {
        return {}
      },
      type: Object
    },
    provinceList: {
      defualt: () => {
        return []
      },
      type: Array
    },
    search: {
      default: () => {},
      type: Function
    },
    exportDate: {
      default: () => {},
      type: Function
    },
    prev: {
      default: () => {},
      type: Function
    }
  }
}
</script>
